<template>
  <div
    :class="[$style.grid_task_text_container, 'gantt_grid_task_text_container']"
    @click.stop
  >
    <input
      ref="inlineEditorText"
      v-model="value"
      type="text"
      class="mousetrap"
      :class="[$style.grid_task_text_input, isEditTask ? $style.grid_task_text_input_edit : '']"
      maxlength="250"
      @keyup.esc="onCancel"
      @blur="onBlur"
    >
    <div class="buffer" />
    <div :class="$style.grid_task_text_buttons">
      <button
        data-testid="gp_autotest_gantt_add_task_button"
        :class="[$style.add_task_button, isEditTask ? $style.add_task_button_edit : '']"
        @click.stop="onSave"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="16"
            height="16"
            rx="2"
            fill="#1565C0"
          />
          <path
            d="M10.4672 5.57393L6.8968 9.53467L5.54126 8.28529C5.33514 8.09532 5.01198 8.11655 4.8325 8.33186C4.66276 8.53547 4.68563 8.83713 4.88413 9.01282L6.5673 10.5027C6.75799 10.6714 7.04854 10.6572 7.2218 10.4706L11.1704 6.21719C11.3393 6.03522 11.3402 5.75401 11.1724 5.57098C10.9825 5.3638 10.6554 5.36517 10.4672 5.57393Z"
            fill="white"
            stroke="white"
            stroke-width="0.2"
          />
        </svg>
      </button>
      <button
        v-if="!isEditTask"
        data-testid="gp_autotest_gantt_cancel_task_button"
        :class="$style.cancel_task_button"
        @click.stop="onCancel"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="16"
            height="16"
            rx="2"
            fill="#F2F2F2"
          />
          <path
            d="M6.10899 5.50156C5.95431 5.34688 5.70353 5.34688 5.54885 5.50156C5.39417 5.65623 5.39417 5.90702 5.54885 6.0617L7.48716 8L5.54885 9.9383C5.39417 10.093 5.39417 10.3438 5.54885 10.4984C5.70353 10.6531 5.95431 10.6531 6.10899 10.4984L8.0473 8.56014L9.9856 10.4984C10.1403 10.6531 10.3911 10.6531 10.5457 10.4984C10.7004 10.3438 10.7004 10.093 10.5457 9.9383L8.60744 8L10.5457 6.0617C10.7004 5.90702 10.7004 5.65623 10.5457 5.50156C10.3911 5.34688 10.1403 5.34688 9.9856 5.50156L8.0473 7.43986L6.10899 5.50156Z"
            fill="#B2B2B2"
            stroke="#B2B2B2"
            stroke-width="0.4"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
const MIN_ADD_INPUT_WIDTH = 178;

export default {
  name: 'GridTextCellEditor',
  props: {
    placeholder: {
      type: Object,
      required: true,
    },
    taskNode: {
      type: Object,
      required: true,
    },
    isEditTask: {
      type: Boolean,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      locales: __,
      value: '',
    };
  },
  created() {
    this.calculateCssStyles();
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.inlineEditorText) {
        this.$refs.inlineEditorText.focus();

        if (this.isEditTask) {
          this.$refs.inlineEditorText.select();
        }
      }
    });
  },
  methods: {
    calculateCssStyles() {
      const container = this.taskNode.querySelector('.text_cell .text_value');

      const coords = container.getBoundingClientRect();
      const placeholderCoords = this.placeholder.getBoundingClientRect();
      const indentOffset = coords.left - placeholderCoords.left;

      this.placeholder.style.left = `${parseInt(this.placeholder.style.left, 10) + indentOffset}px`;
      this.placeholder.style.width = `${parseInt(this.placeholder.style.width, 10) - indentOffset - 8}px`;

      if (!this.isEditTask) {
        this.placeholder.style.maxWidth = `${coords.right - placeholderCoords.left - indentOffset}px`;
        this.placeholder.style.width = `${MIN_ADD_INPUT_WIDTH}px`;
      }
    },

    onBlur() {
      // keep focus after instance render
      setTimeout(() => {
        if (this.$refs.inlineEditorText) {
          this.$refs.inlineEditorText.focus();
        }
      });
    },
  },
};
</script>

<style module src="./gridTextCellEditor.less" lang="less"></style>
